import gql from 'graphql-tag';

export default gql`
  mutation AnalyzeIngredient($input: DailyTrackerAnalyzeIngredientInputType!) {
    dailyTracker {
      analyzeIngredient(input: $input) {
        ... on AnalyzedDailyTrackerIngredients {
          primaryIngredient {
            productId
            name
            brand
            baseAmount
            baseUnit
            calories
            proteinGrams
            carbsGrams
            fatGrams
            measures {
              measureId
              unit
              amount {
                value
                unit
              }
            }
          }
          alternateIngredients {
            productId
            name
            brand
            baseAmount
            baseUnit
            calories
            proteinGrams
            carbsGrams
            fatGrams
            measures {
              measureId
              unit
              amount {
                value
                unit
              }
            }
          }
          hasAlternates
        }
        ... on NotFoodError {
          message
          description
        }
        ... on ProductNotFoundError {
          message
          description
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
